/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/require-default-props */
/* eslint-disable react/no-array-index-key */
import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Dropdown, DropdownMenu, DropdownItem, DropdownToggle } from 'reactstrap';
import { AppContext } from 'helpers';
import { NEPAL_TZ, Localization } from 'constant';
import moment from 'moment';
import NepaliDate from 'nepali-date';
import Arrow from 'components/layouts/Arrow';
import Calendar from 'components/icons/calendar';

interface Props {
  handleChange: (m: string, y: string) => void;
  width?: any;
}

const MonthDropdown = ({ handleChange, width = '200px' }: Props) => {
  const { t } = useTranslation();
  const [dropdownOpen, setDropdownOpen] = useState<boolean>(false);
  const { month, year, timezone, monthList } = useContext(AppContext);

  const toggle = () => setDropdownOpen((prevState) => !prevState);
  const [list, setList] = useState<any>([]);
  const [active, setActive] = useState<any>({
    monthIndex: null,
    year: null,
  });

  useEffect(() => {
    if (list.length === 0) renderMonthList();
  }, []);

  useEffect(() => {
    setActive({
      monthIndex: month,
      year,
    });
  }, [month, year]);

  const handleSelectItem = (m: string, y: string) => {
    const finding = monthList.findIndex((item: string) => item === m);

    if (finding > -1) {
      setActive({
        monthIndex: finding,
        year: y,
      });
      handleChange(finding.toString(), y);
    }
  };

  const renderMonthList = () => {
    let currMo = timezone === NEPAL_TZ ? new NepaliDate().format('MM') - 1 : +moment().format('MM');
    const currDate = timezone === NEPAL_TZ ? new NepaliDate().format('DD') - 1 : +moment().format('DD');
    const y = timezone === NEPAL_TZ ? new NepaliDate().format('YYYY') : +moment().format('YYYY');

    if (currDate < Localization.dateTime.startDate) {
      currMo -= 1;
    }
    const mL = [...Array(12)].map((_, i) => {
      let m = '';
      if (+currMo - i >= 0) {
        m = `${monthList[+currMo - i]} ${y}`;
      } else {
        m = `${monthList[12 + (+currMo - i)]} ${y - 1}`;
      }
      return m;
    });
    setList(mL);
  };

  const renderItem = (item: any) => {
    const st = item.split(' ');
    return (
      <DropdownItemStyle
        key={item}
        onClick={() => {
          handleSelectItem(st[0], st[1]);
        }}
        // className={+active.monthIndex === indx ? 'active' : ''}
      >
        {t(item)}
      </DropdownItemStyle>
    );
  };

  const dropDown = () => {
    return (
      <Dropdown
        isOpen={dropdownOpen}
        toggle={toggle}
        style={{
          border: '1px solid #6956BA',
          height: '56px',
          borderRadius: '8px',
          background: '#fff',
          width,
        }}
      >
        <DropdownToggleStyle color="x" className="p-3 border-0 justify-content-between" role="button">
          <div style={{ width: 'max-content' }}>
            {t(active ? `${monthList[Number(active.monthIndex)]} ${active.year}` : '')}
          </div>
          <div style={{ width: '100px' }} />
          <div style={{ alignSelf: 'center', right: '10px', position: 'absolute' }}>
            <Arrow border={2} length={9} color="#666666" rotate={45} />
          </div>
        </DropdownToggleStyle>

        <DropdownMenuStyle className="mt-2">{list && list.map((item: any) => renderItem(item))}</DropdownMenuStyle>
      </Dropdown>
    );
  };

  return dropDown();
};

export const DropdownItemStyle = styled(DropdownItem)`
  &.active {
    background: #ffcc4d;
  }
`;

export const DropdownMenuStyle = styled(DropdownMenu)`
  ::-webkit-scrollbar-thumb {
    background-color: darkgray;
    border-radius: 100em;
  }
  ::-webkit-scrollbar-track {
    background-color: white;
    border-radius: 100em;
  }
  ::-webkit-scrollbar {
    width: 5px;
  }
`;

export const DropdownToggleStyle = styled(DropdownToggle)`
  &.btn {
    color: #263238;
    font-size: 16px;
    font-weight: 400;
    display: flex;
    flex-direction: row;
    &:hover,
    &:focus,
    &:visited {
      text-decoration: none;
    }
  }
`;

export default MonthDropdown;
